import secureLocalStorage from "react-secure-storage";
import * as React from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
export default class ActionType extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownListData: [],
    };
  }
  componentDidMount = () => {
    if (this.props.dataItem.inEdit && document.getElementById("actionTypeid")) {
      document.getElementById("actionTypeid").focus();
      this.init();
    }
  };
  init=()=>{
    this.setState({
      dropdownListData: this.props.actionTypeListForRisk,
    });
  }
  handleChange = (e) => {
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value.text,
    });
  };

  handleEditCell = () => {
    if(this.props.dataItem.isOpen==="Open" || this.props.dataItem.isOpen===true){
    this.props.onEditCell(this.props.dataItem, this.props.field);
  }
  };
  handlefilter = (e) => {
    const filteredvalue = filterBy(this.props.actionTypeListForRisk, e.filter);
    this.setState({
      dropdownListData: filteredvalue,
    });
  };
  getSortedList = () => {
    let sorteddropdownlist = this.state.dropdownListData.sort(function (a, b) {
      if (a.text < b.text) {
        return -1;
      }
      if (a.text > b.text) {
        return 1;
      }
      return 0;
    });
    return sorteddropdownlist;
  };
  render() {
    const { dataItem, field, actionTypeListForRisk } = this.props;
    const dataValue =
      dataItem[field] === null || dataItem[field] == undefined
        ? ""
        : dataItem[field];
    const loginUserId = parseInt(secureLocalStorage.getItem("loginUserId"));
    const ownerId = dataItem.userId;
    const riskOwnerId = this.props.riskDetails
      ? this.props.riskDetails.userId
      : null;
   
    if (field && dataItem.inEdit === field) {
      return (
        <DropDownList
          style={{ width: "100px" }}
          onChange={this.handleChange}
          value={actionTypeListForRisk.find((c) => c.value === dataValue)}
          data={this.getSortedList()}
          textField="text"
          id="actionTypeid"
          filterable={true}
          onFilterChange={(e) => this.handlefilter(e)}
          opened={true}
        />
      );
    } else {
      if (
        (loginUserId === ownerId || loginUserId === riskOwnerId) &&
        this.props.dataItem.isOpen === true
      ) {
        return (
          <td onClick={this.handleEditCell}>
            {dataValue === " [blank]" ? "" : dataValue}
          </td>
        );
      } else {
        return this.props.dataItem.role == "View Only" ||
          this.props.dataItem.role == "Standard User" ||
          this.props.dataItem.isOpen == false ? (
          <td>{dataValue === " [blank]" ? "" : dataValue}</td>
        ) : (
          <td onClick={this.handleEditCell}>
            {dataValue === " [blank]" ? "" : dataValue}
          </td>
        );
      }
    }
  }
}
